import { QuestionAnswerMap } from '@care-portals/api-interfaces';

export const hemorrhoidQuestions = [
  {
    field: 'hemorrhoid_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'hemorrhoid_ineligible',
    label: "We're sorry you don't qualify.",
    subLabel:
      'Based on your responses, there are concerning signs that go beyond what can be safely managed remotely. Please seek in-person medical care as soon as possible. It’s important to rule out anything more serious and ensure you get the right treatment. A refund will process between 5 - 10 business days.',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    field: 'hemorrhoid_nonConsent',
    isLast: true,
    label: `We understand that you do not consent. Please seek in-person care and a refund will process between 5 - 10 business days`,
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'hemorrhoid_sex',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    label: 'Are you currently pregnant or planning to become pregnant?',
    field: 'hemorrhoid_pregnant',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Which trimester are you in?',
    field: 'hemorrhoid_trimester',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'First trimester (weeks 0–13)',
          key: 'first'
        },
        {
          value: 'Second trimester (weeks 14–27)',
          key: 'second'
        },
        {
          value: 'Third trimester (weeks 28–delivery)',
          key: 'third'
        },
        {
          value: 'I’m planning on becoming pregnant soon',
          key: 'planning'
        }
      ]
    }
  },
  {
    label: 'Consent (pregnancy):',
    educationalSlide:
      'The formulations available through this service have been reviewed and approved by board-certified OB/GYNs and contain only ingredients that, on current evidence, are considered Pregnancy Category C. Pregnancy Category C means that animal studies have shown potential risks to the fetus, but there are no well-controlled studies in pregnant women. You must consult your own prenatal care provider before starting, continuing, or modifying any treatment obtained here to ensure it is appropriate for your specific medical history and gestational stage.',
    field: 'hemorrhoid_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and do NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'I have read and understand the above information, I understand the risks and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'hemorrhoid_height',
    type: 'info',
    answer: { type: 'text', rows: 4, name: 'hemorrhoid_height' }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'hemorrhoid_weight',
    type: 'info',
    answer: { type: 'text', rows: 4, name: 'hemorrhoid_weight' }
  },
  {
    label:
      'Do you get migraines or chronic headaches that worsen with nitrate medicines?',
    field: 'hemorrhoid_migranesThatWorsenWithNitrate',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Have you ever had a reaction to, or treatment failure with, nitroglycerin cream?',
    field: 'hemorrhoid_reactionToNitroglycerinCream',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'I don’t know', key: 'dontKnow' }
      ]
    }
  },
  {
    label:
      'Have you previously tried a topical anorectal medication such as diltiazem and had a reaction or have a known allergy to diltiazem, or a failure of treatment?',
    field: 'hemorrhoid_allergyToDiltiazem',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'I don’t know', key: 'dontKnow' }
      ]
    }
  },
  {
    label: 'Do you have a history of cancer?',
    field: 'hemorrhoid_historyOfCancer',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Tell us about your previous cancer diagnosis (Select all that apply)',
    field: 'hemorrhoid_previousCancerDiagnosis',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'I have a history of colon, rectal, anal, or stomach cancer',
          key: 'rectalCancer'
        },
        {
          value: 'I have a history of breast cancer',
          key: 'breast'
        },
        {
          value: 'I have a history of lunger cancer',
          key: 'lunger'
        },
        {
          value: 'I have a history of another cancer',
          key: 'another'
        }
      ]
    }
  },
  {
    label: 'Have you been treated for colorectal or anal cancer?',
    field: 'hemorrhoid_treatedForCancer',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'With chemotherapy', key: 'chemotherapy' },
        { value: 'With radiation', key: 'radiation' },
        { value: 'With chemotherapy and radiation', key: 'chemotherapyAndRadiation' },
        { value: 'With surgery', key: 'surgery' },
        { value: 'All of the above', key: 'allOfTheAbove' },
      ]
    }
  },
  {
    label: 'Do you have an ostomy?',
    field: 'hemorrhoid_ostomy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Ileostomy', key: 'ileostomy' },
        { value: 'Colostomy', key: 'colostomy' },
        { value: 'Both', key: 'both' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label: 'Have you been diagnosed with low anterior resection syndrome (LARS)?',
    field: 'hemorrhoid_lars',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'I don\'t know', key: 'dontKnow' }
      ]
    }
  },
  {
    label: 'Do you have residual symptoms from colorectal or anal cancer treatment such as anal pain, difficulty with bowel movements, or bleeding?',
    field: 'hemorrhoid_residualSymptoms',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
      ]
    }
  },
  {
    label:
      'Do any of your first degree family members have a history of cancer?',
    field: 'hemorrhoid_familyCancerHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Tell us about your family history of cancer (Select all that apply)',
    field: 'hemorrhoid_moreAboutFamilyCancerHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have a family history of colon, rectal, anal, or stomach cancer',
          key: 'rectalCancer'
        },
        {
          value: 'I have a family history of breast cancer',
          key: 'breast'
        },
        {
          value: 'I have a family history of lunger cancer',
          key: 'lunger'
        },
        {
          value: 'I have a family history of another cancer',
          key: 'another'
        }
      ]
    }
  },
  {
    label: 'What symptoms are you experiencing? (Select  all that apply)',
    field: 'hemorrhoid_routingBasedOnSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Pain', key: 'pain' },
        { value: 'Bleeding', key: 'bleeding' },
        { value: 'Swelling', key: 'swelling' }
      ]
    }
  },
  {
    label: 'How would you describe the pain? (Check all that apply)',
    field: 'hemorrhoid_pain_painLevel',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Sharp / stabbing', key: 'sharp' },
        {
          value: 'Dull / achy / throbbing',
          key: 'dull'
        },
        { value: 'Pressure-like', key: 'pressure-like' },
        { value: 'Burning', key: 'burning' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label: 'Tell us more about your other pain that you experience',
    field: 'hemorrhoid_pain_moreAboutPainLevel',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'hemorrhoid_pain_moreAboutPainLevel'
    }
  },
  {
    label: 'Where do you feel the pain?',
    field: 'hemorrhoid_pain_painLocation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Inside the anus', key: 'inside' },
        { value: 'Outside the anus', key: 'outside' },
        {
          value: 'Both inside and outside',
          key: 'inAndOutside'
        },
        { value: 'Not sure', key: 'notSure' }
      ]
    }
  },
  {
    label: 'When do you experience this pain? (Select all that apply)',
    field: 'hemorrhoid_pain_painTime',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Only during bowel movements',
          key: 'bowelMovements'
        },
        { value: 'At random times', key: 'randomTimes' },
        {
          value: 'During and after a bowel movement, lasting minutes to hours',
          key: 'aroundBowelMovements'
        }
      ]
    }
  },
  {
    label: 'How long does each episode last?',
    field: 'hemorrhoid_pain_lengthOfPainEpisode',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Seconds', key: 'seconds' },
        { value: 'Minutes', key: 'minutes' },
        { value: 'Hours', key: 'hours' }
      ]
    }
  },
  {
    label: 'Do any of the following seem to help? (Check all that apply)',
    field: 'hemorrhoid_pain_painRelief',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Warm bath or sitz bath', key: 'warmBath' },
        { value: 'Ice or cold compress', key: 'coldCompress' },
        {
          value: 'Over-the-counter pain pills',
          key: 'OTCpainPills'
        },
        {
          value: 'Over-the-counter hemorrhoid creams or wipes',
          key: 'OTCcreams'
        },
        { value: 'Something else', key: 'somethingElse' }
      ]
    }
  },
  {
    label: 'Provide more information regarding what helps ease your pain',
    field: 'hemorrhoid_pain_moreAboutPainRelief',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'hemorrhoid_pain_moreAboutPainRelief'
    }
  },
  {
    label:
      'What over-the-counter (OTC) treatments have you already tried? (Check all that apply)',
    field: 'hemorrhoid_pain_treatementWithOTC',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Preparation H or generic equivalent',
          key: 'preparationH'
        },
        {
          value: 'Witch-hazel wipes, cream, or foam',
          key: 'witchHazel'
        },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label:
      'Provide more information regarding what OTC treatment that you have tried',
    field: 'hemorrhoid_pain_moreAboutOTC',
    type: 'info',
    answer: { type: 'text', rows: 4, name: 'hemorrhoid_pain_moreAboutOTC' }
  },
  {
    label: 'How often do you usually have a bowel movement?',
    field: 'hemorrhoid_pain_bowelMoveMent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Daily', key: 'Daily' },
        { value: 'Every 2–3 days', key: 'Every 2–3 days' },
        { value: 'Less predictable', key: 'Less predictable' }
      ]
    }
  },
  {
    label: 'Do you see bright red blood during bowel movements?',
    field: 'hemorrhoid_bleeding_redBloodDuringBowelMovement',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Where do you see it?',
    field: 'hemorrhoid_bleeding_locationOfBlood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'On the toilet paper', key: 'toiletPaper' },
        { value: 'Dripping into the bowl', key: 'dripping' },
        { value: 'Both', key: 'both' }
      ]
    }
  },
  {
    label: 'How often do you notice bleeding?',
    field: 'hemorrhoid_bleeding_bleedingRecurrence',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Every bowel movement', key: 'every' },
        {
          value: 'Sometimes throughout the day',
          key: 'sometimes'
        },
        { value: 'It only happened once', key: 'once' }
      ]
    }
  },
  {
    label: 'When was the most recent episode?',
    field: 'hemorrhoid_bleeding_lengthOfEpisode',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'hemorrhoid_bleeding_lengthOfEpisode'
    }
  },
  {
    label: 'Is the bleeding painful or painless?',
    field: 'hemorrhoid_bleeding_bleedingType',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Painful', key: 'painful' },
        { value: 'Painless', key: 'painless' }
      ]
    }
  },
  {
    label: 'Have you ever passed dark, tar-like stools?',
    field: 'hemorrhoid_bleeding_darkStool',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'Have you noticed any of the following?',
    field: 'hemorrhoid_swelling_symptom',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'A lump that feels like a golf ball',
          key: 'lump'
        },
        {
          value: 'A small bluish lump (like a blueberry/grape)',
          key: 'blueLump'
        },
        { value: 'Yellowish discharge', key: 'yellowish' },
        {
          value:
            'Swelling that worsens when you sit, stand, or drive for long periods',
          key: 'swellingFromSitting'
        }
      ]
    }
  },
  {
    label: 'Have there been any recent triggers? (Check all that apply)',
    field: 'hemorrhoid_swelling_triggers',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Long car or plane ride', key: 'Long car or plane ride' },
        { value: 'Diet change', key: 'dietChange' },
        {
          value: 'Heavy lifting or strenuous exercise',
          key: 'strenuousExercise'
        },
        { value: 'High stress', key: 'highStress' },
        {
          value: 'Prolonged sitting (e.g., at a computer desk)',
          key: 'prolongedSitting'
        }
      ]
    }
  },
  {
    label:
      'Do you have anal receptive intercourse or have you had any recent anal trauma?',
    field: 'hemorrhoid_swelling_receptiveIntercourse',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Do you have a known diagnosis of HPV, genital warts, HIV, or other STIs?',
    field: 'hemorrhoid_swelling_STI',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'While our medications may still be prescribed, we want to make sure you are getting the care you need. Please confirm you will see an in-person provider for STI care',
    field: 'hemorrhoid_swelling_inPersonConfirmation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'Yes, I’m currently receiving treatment or have been successfully treated',
          key: 'receivingTreatment'
        },
        {
          value: 'No I will not seek care for this',
          key: 'notSeekCare'
        }
      ]
    }
  },
  {
    label: 'How frequent are your bowel movements?',
    field: 'hemorrhoid_frequencyOfBowelMovements',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Daily', key: 'daily' },
        { value: 'Every other day', key: 'otherDay' },
        { value: 'Every 2–3 days', key: '2-3days' },
        { value: 'Less than 3 per week', key: '3perWeek' }
      ]
    }
  },
  {
    label: 'Do you tend to have any of the below?',
    field: 'hemorrhoid_otherIssues',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Constipation', key: 'constipation' },
        { value: 'Diarrhea', key: 'diarrhea' },
        { value: 'Both', key: 'both' },
        { value: 'Neither', key: 'neither' }
      ]
    }
  },
  {
    label: 'Do you strain or push hard more than a few days a week?',
    field: 'hemorrhoid_strain',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'What does your stool usually look like?',
    field: 'hemorrhoid_stoolExam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Type 1: Separate hard lumps, like nuts',
          key: 'Type1'
        },
        {
          value: 'Type 2: Sausage-shaped but lumpy',
          key: 'Type2'
        },
        {
          value: 'Type 3: Like a sausage with surface cracks',
          key: 'Type3'
        },
        {
          value: 'Type 4: Smooth, soft sausage or snake',
          key: 'Type4'
        },
        {
          value: 'Type 5: Soft blobs with clear edges',
          key: 'Type5'
        },
        {
          value: 'Type 6: Fluffy pieces with ragged edges (mushy)',
          key: 'Type6'
        },
        {
          value: 'Type 7: Watery, no solid pieces',
          key: 'Type7'
        }
      ]
    }
  },
  {
    label:
      'Have you used laxatives, stool-softeners, or fiber supplements in the past month?',
    field: 'hemorrhoid_supplements',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'hemorrhoid_otherInformation',
    type: 'info',
    answer: { type: 'text', rows: 4, name: 'hemorrhoid_otherInformation' }
  },

  {
    label: 'Consent (Truthfulness):',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.
      
        I verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    field: 'hemorrhoid_truthfulnessConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label:
      'Consent (Topical Medications for Hemorrhoids, Anal Fissures, and Pruritus Ani):',
    educationalSlide: `You have reported symptoms consistent with hemorrhoids, anal fissures, pruritus ani, or a combination of these conditions. These may include rectal pain, itching, burning, bleeding, or discomfort with bowel movements. Bummed offers compounded topical medications formulated to relieve these symptoms by targeting inflammation, internal sphincter spasm, nerve irritation, or local infection.
        
        You are being prescribed a custom-compounded topical formulation that may contain one or more of the following ingredients:
        - Diltiazem, Nifedipine, or Nitroglycerin - reduce anal sphincter tone and improve blood flow, which can aid fissure healing and reduce symptoms of hemorrhoids
        - Hydrocortisone - reduces localized inflammation and itching
        - Metronidazole - used for its anti-inflammatory and antimicrobial effects
        - Lidocaine and Bupivacaine - local anesthetics that provide short- and long-acting pain relief
        - Clotrimazole - used externally to treat fungal causes of anal itching
        
        Common formulations may include:
        - Diltiazem 2% / Hydrocortisone 2% / Lidocaine 5% / Bupivacaine 1%
        - Nitroglycerin 0.1% / Hydrocortisone 2% / Metronidazole 10% / Lidocaine 5% / Bupivacaine 1%
        - Nifedipine 0.5% / Hydrocortisone 2% / Lidocaine 5% / Bupivacaine 1%
        - Clotrimazole 1% / Hydrocortisone 2% (for external use only)
        
        These medications are prepared by a compounding pharmacy for topical anorectal use only.
    
        Use During Pregnancy and Breastfeeding:
    
        Several ingredients used in these compounded medications are considered pregnancy category C, meaning animal studies have shown potential risk and human data is limited. These include:
        - Diltiazem, Nifedipine, Nitroglycerin, Hydrocortisone, Bupivacaine, and Metronidazole
    
        While these medications are commonly used off-label by colorectal specialists during pregnancy, especially in the second and third trimesters, their safety has not been firmly established in pregnancy or while breastfeeding. These medications may be considered when symptoms are severe or refractory and when benefits outweigh potential risks.
        - Lidocaine (category B) is generally considered safe for short-term use.
        - Clotrimazole (category B) is commonly used during pregnancy for external fungal conditions.
        - Metronidazole (category B) is generally considered safe for short-term use.
        
        If you are currently pregnant, trying to conceive, or breastfeeding, please make sure your in-person healthcare provider is aware. Use of these compounds should be based on a shared decision-making discussion with your provider.
    
        Expected Benefits
        - Relief from anal pain, itching, burning, or pressure
        - Promotion of healing in chronic anal fissures
        - Reduction of hemorrhoidal swelling and discomfort
        - Improved comfort during and after bowel movements
    
        Possible Side Effects
        - While these medications are typically well tolerated, side effects may include:
        - Local irritation, stinging, or redness at the site of application
        - Headaches (more common with nitroglycerin)
        - Dizziness or lightheadedness
        - Rare allergic reactions such as rash, swelling, or sensitivity
        - Do not ingest these medications or apply them to broken skin unless specifically directed. Nitroglycerin-containing compounds should be avoided in patients with a history of migraines, low blood pressure, or who are taking nitrates or certain recreational drugs.
    
        Alternative Treatments
        - Warm sitz baths
        - Lifestyle and toileting modifications
        - Topical non-medicated agents (e.g., witch hazel, petroleum jelly)
        - Fiber and stool softeners
        - In-office procedures (e.g., banding, thrombectomy) if indicated
    
        Your Consent
    
        I understand the potential benefits, risks, and limitations of using these compounded topical medications. I understand that use during pregnancy and breastfeeding requires special consideration and should be guided by my provider. I agree to follow the directions provided and to report any concerning symptoms or lack of improvement.
    
        I understand that this consent is voluntary and that I may discontinue treatment at any time.
    
        By selecting below, I consent to the use of these topical anorectal medications for the treatment of my condition.`,
    field: 'hemorrhoid_consent',
    type: 'select',

    answer: {
      type: 'single_select',
      options: [
        {
          value: 'No, I do not consent',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'Yes, I have read and consent',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

const _type = [...hemorrhoidQuestions] as const;

export type HemorrhoidFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default hemorrhoidQuestions;
